{"locales":["de","en"],"defaultLocale":"en"}